import React from 'react'
import { Box, IconButton, Typography } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'

interface AppTitleBarProps {
    title: string
    backLabel: string
    onBack: () => void
}

/** Stands in for the site header inside the native app: the app has no chrome of its own here. */
const AppTitleBar: React.FC<AppTitleBarProps> = ({ title, backLabel, onBack }) => {
    return (
        <Box
            component="header"
            sx={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                minHeight: 56,
                px: 0.5,
                bgcolor: 'background.paper',
                borderBottom: '1px solid',
                borderColor: 'borders.default'
            }}
        >
            <IconButton onClick={onBack} aria-label={backLabel} sx={{ color: 'textColors.primary' }}>
                <ArrowBackIcon sx={{ '[dir=rtl] &': { transform: 'scaleX(-1)' } }} />
            </IconButton>

            <Typography
                component="p"
                sx={{
                    // Centred on the bar, not between the button and the edge.
                    position: 'absolute',
                    insetInlineStart: 56,
                    insetInlineEnd: 56,
                    textAlign: 'center',
                    fontSize: '1rem',
                    fontWeight: 700,
                    color: 'textColors.primary',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }}
            >
                {title}
            </Typography>
        </Box>
    )
}

export { AppTitleBar }
export type { AppTitleBarProps }
export default AppTitleBar
